import React from 'react'
import './SeparateLine.css'

const SeparateLine = () =>{
    return(
        <div className='separateLine' />
    )
}

export default SeparateLine